import { KpiBlock as KpiBlockType, BlockAction } from '../../types/panel'
import BlockActions from './BlockActions'

function Sparkline({ values }: { values: number[] }) {
  if (values.length < 2) return null
  const min = Math.min(...values)
  const max = Math.max(...values)
  const range = max - min || 1
  const w = 60, h = 20
  const pts = values.map((v, i) =>
    `${(i / (values.length - 1)) * w},${h - ((v - min) / range) * (h - 2) - 1}`
  ).join(' ')
  return (
    <svg width={w} height={h} className="k-kpi__spark" aria-hidden="true">
      <polyline points={pts} fill="none" stroke="var(--green-900)" strokeWidth={1.5} />
    </svg>
  )
}

interface Props { block: KpiBlockType; onAction?: (action: BlockAction) => void }

export default function KpiBlock({ block, onAction }: Props) {
  const kpis = Array.isArray(block.kpis) ? block.kpis : []
  return (
    <div className="k-block">
      <h4 className="k-block__title">{block.title}</h4>
      {block.subtitle && <div className="k-block__sub">{block.subtitle}</div>}
      <div className="k-kpis k-kpis--auto">
        {kpis.map((k, i) => (
          <div className="k-kpi" key={i}>
            <div className="k-kpi__label">{k.label}</div>
            <div className="k-kpi__value">
              {k.prefix ? `${k.prefix} ` : ''}
              {typeof k.value === 'number' ? k.value.toLocaleString('de-DE') : k.value}
            </div>
            {k.delta !== undefined && (
              <div className={'k-kpi__delta' + (k.delta >= 0 ? '' : ' is-bad')}>
                {k.delta >= 0 ? '+' : '−'}{Math.abs(k.delta).toLocaleString('de-DE')}
              </div>
            )}
            {k.spark && <Sparkline values={k.spark} />}
          </div>
        ))}
      </div>
      <BlockActions actions={block.actions} onAction={onAction} />
    </div>
  )
}
